import { render, staticRenderFns } from "./PrecalificationDashboard.vue?vue&type=template&id=564e991e&scoped=true"
import script from "./PrecalificationDashboard.vue?vue&type=script&lang=js"
export * from "./PrecalificationDashboard.vue?vue&type=script&lang=js"
import style0 from "./PrecalificationDashboard.vue?vue&type=style&index=0&id=564e991e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e991e",
  null
  
)

export default component.exports